import React from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import { neutral } from '../../style/colors';
import { useMedia } from '../../hooks/useMedia';
import { size } from '../../style/util';

const TilesLoading = (props: TilesLoadingPropTypes) => {
  const { show, sidebarToggled } = props;
  const isSmallScreen = useMedia(
    [`(max-width: ${size.small}px)`],
    [true],
    false
  );
  const fade = useSpring({
    opacity: show ? 1 : 0,
    bottom:
      sidebarToggled && isSmallScreen
        ? 'calc(40vh + 2px)'
        : 'calc(0vh + 100px)',
    position: 'absolute',
    zIndex: 2,
    left: 15,
    display: 'inline-block',
    width: 30,
    height: 30,
  });
  return (
    <animated.div style={fade}>
      <Wrapper>
        <div />
        <div />
        <div />
        <div />
      </Wrapper>
    </animated.div>
  );
};

const Wrapper = styled.div`
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    margin: 5px;
    border: 3px solid ${neutral[600]};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${neutral[600]} transparent transparent transparent;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
interface TilesLoadingPropTypes {
  show: boolean;
  sidebarToggled: boolean;
}
export default TilesLoading;
